import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseOverviewService} from '../../../shared/services/popular-course-overview.service';
import {environment} from '../../../../environments/environment';

interface OverviewTableRow {
    aspect: string;
    details: string[];
}

interface OverviewEditorBlock {
    type: 'content' | 'table';
    value: string;
}

import {UtilsService} from '../../../shared/services/utils.service';
@Component({
    selector: 'app-popular-course-overview',
    templateUrl: './popular-course-overview.component.html',
    styleUrls: ['./popular-course-overview.component.scss']
})
export class PopularCourseOverviewComponent implements OnInit {
    public popularCourseId: any;
    submitting: any = false;
    dataExists: any = false;
    // Superseded by the rich table editor below (table_html) — kept commented out for now
    // in case the structured Aspect/Details table needs to come back.
    // tableRows: OverviewTableRow[] = [];
    editorBlocks: OverviewEditorBlock[] = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseOverviewService: PopularCourseOverviewService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.popularCourseOverviewService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.dataExists = !!(data && data['info']);
            // this.tableRows = (data && data['table_data'] && data['table_data'].length) ? data['table_data'] : [];
            // if (this.tableRows.length === 0) {
            //     this.addRow();
            // }

            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    // addRow() {
    //     this.tableRows.push({aspect: '', details: ['']});
    // }
    //
    // removeRow(index: number) {
    //     this.tableRows.splice(index, 1);
    // }
    //
    // addDetail(rowIndex: number) {
    //     this.tableRows[rowIndex].details.push('');
    // }
    //
    // removeDetail(rowIndex: number, detailIndex: number) {
    //     this.tableRows[rowIndex].details.splice(detailIndex, 1);
    // }

    submit() {
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);

        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
            // 'table_data': cleanedRows — commented out along with the structured table UI below
        };
        this.submitting = true;
        if (this.dataExists) {
            this.popularCourseOverviewService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        } else {
            this.popularCourseOverviewService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
            });
        }
    }
}
